import apiClient from '../../../services/apiClient';

const P = '/monitoring';

// 시스템 개요
export const fetchOverview = () => apiClient.get(P);
export const fetchDailyDigest = () => apiClient.get(`${P}/daily-digest`);

// 서비스 운영 관리
export const fetchRecentActivity = (limit = 30) =>
  apiClient.get(`${P}/recent-activity`, { params: { limit } });
export const fetchSignupHistory = (period, page, size) =>
  apiClient.get(`${P}/signup-history`, { params: { period, page, size } });
export const fetchSubscribeHistory = (period, planType, page, size) =>
  apiClient.get(`${P}/subscribe-history`, { params: { period, plan_type: planType, page, size } });
export const fetchSiteHistory = (period, page, size) =>
  apiClient.get(`${P}/site-history`, { params: { period, page, size } });

// API 모니터링
export const fetchApiStats = (period) =>
  apiClient.get(`${P}/api-stats`, { params: { period } });
export const fetchResponseTimeTrend = (period) =>
  apiClient.get(`${P}/response-time-trend`, { params: { period } });
export const fetchSlowRequests = (period, thresholdMs, limit) =>
  apiClient.get(`${P}/slow-requests`, { params: { period, threshold_ms: thresholdMs, limit } });
export const fetchErrorSummary = (period) =>
  apiClient.get(`${P}/error-summary`, { params: { period } });
export const fetchErrorLogs = (period, limit) =>
  apiClient.get(`${P}/error-logs`, { params: { period, limit } });
export const fetchUserActivity = (period, limit) =>
  apiClient.get(`${P}/user-activity`, { params: { period, limit } });

// 비즈니스 집계
export const fetchClientStats = () => apiClient.get(`${P}/client-stats`);
export const fetchSiteStats = () => apiClient.get(`${P}/site-stats`);
export const fetchSubscribeStats = () => apiClient.get(`${P}/subscribe-stats`);
export const fetchRevenueStats = (period) =>
  apiClient.get(`${P}/revenue-stats`, { params: { period } });
export const fetchExtensionStats = () => apiClient.get(`${P}/extension-stats`);
export const fetchMemberStats = () => apiClient.get(`${P}/member-stats`);
export const fetchStandardStats = () => apiClient.get(`${P}/standard-stats`);

// 람다 로그 현황
export const fetchLambdaStatus = () => apiClient.get(`${P}/lambda-status`);
export const fetchLambdaErrors = (hours, limit) =>
  apiClient.get(`${P}/lambda-errors`, { params: { hours, limit } });
export const fetchPaymentActivity = (hours) =>
  apiClient.get(`${P}/payment-activity`, { params: { hours } });
